module.exports = __webpack_public_path__ + "img/dfb60fa.png";